import { exportStates } from 'json'
export let historyTableLabels = [{
  label: '文件名',
  value: 'name'
},
{
  label: '导出时间',
  value: 'created_date'
},
{
  label: '状态',
  value: 'exportStates'
}
]

export let historyInTableLabels = [{
  label: '样本接收单号',
  value: 'samplesReceivingOrder',
  width: '250px'
},
{
  label: '文件名',
  value: 'filename',
  width: '250px'
},
{
  label: '客户',
  value: 'customer'
},
{
  label: '导入时间',
  value: 'startTime'
},
{
  label: '操作用户',
  value: 'operationInformation.name'
},
{
  label: '条目数',
  value: 'countTotal'
},
{
  label: '成功创建订单数',
  value: 'countSuccess'
},
{
  label: '异常数',
  value: 'countFailed'
}
]

export let historyInTableLabelsOfImport = [

  {
    label: '文件名',
    value: 'filename'
  },
  {
    label: '导入时间',
    value: 'start_time'
  },
  {
    label: '状态',
    value: 'exportStates'
  }
]
// 导出状态
export let exportState = exportStates
